import React from 'react'
import Head from 'next/head'
import {Leaderboard} from '@components/Leaderboard'
import {InnerPageHeader} from '@components/InnerPageHeader'

const LeaderboardPage = () => {
  return (
    <>
      <Head>
        <title key="title">Leaderboard | CSSBattle</title>
        <meta
          property="og:title"
          content="Leaderboard | CSSBattle"
          key="ogTitle"
        />
      </Head>
      <InnerPageHeader icon="trophy" title="Leaderboards" />

      <div style={{marginTop: '1rem'}}>
        <Leaderboard />
      </div>
    </>
  )
}

export default LeaderboardPage
